import queryString from 'query-string';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import authService from 'services/authService';

import { getHomePage } from 'store/app/selectors';
import { getIsLoggedIn } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import { types, discover } from './actions';

export function* initDiscover(loc) {
  const isLoggedIn = yield select(getIsLoggedIn);
  if (isLoggedIn) {
    const next = queryString.parse(loc.location.search).next;
    next ? history.push(next) : history.push(yield select(getHomePage));
  } else {
    yield put(discover.reset());
  }
}

export function* watchDiscover(action) {
  try {
    const { email, next } = action.payload;

    // 1. Check DjangoSAML SSO first. If the user has SSO configured, redirect
    //    immediately without showing a password field.
    try {
      const ssoConfig = yield call(authService.discoverSSO, { email });
      if (ssoConfig?.ssoUrl) {
        yield put(discover.success());
        window.location.replace(ssoConfig.ssoUrl);
        return;
      }
    } catch (_) {
      // No SSO for this user — fall through to password/OIDC check.
    }

    // 2. Not an SSO user — check for Authentik OIDC or plain password.
    const response = yield call(authService.discover, { email, next });

    if (response.next === 'oidc') {
      yield put(discover.success());
      window.location.replace(response.oidcUrl);
    } else {
      // Password path: signal the form to show the password step in-place.
      yield put(discover.success({ email }));
    }
  } catch (error) {
    yield put(discover.error(getErrorMessage(error, 'Unknown error')));
  }
}

export default function* root() {
  yield takeLatest(types.DISCOVER, watchDiscover);
}
